import { Row, Col, Card, Button, Input, InputNumber, Form, Spin } from "antd";
import { useState, useEffect } from "react";
import useRequest from "../../hooks/useRequest";
import { ShowToast, Severty } from "../../helper/toast";
import apiPath from "../../constants/apiPath";

function Index() {

  const sectionName = "Setting";

  const api = {
    addEdit   :   apiPath.addEditSetting,
    view      :   apiPath.commonSetting,
  };

  const [form]                =   Form.useForm();
  const { request }           =   useRequest();
  const [loadingFetch, setLoadingFetch]   = useState(false);
  const [loadingSubmit, setLoadingSubmit] = useState(false);

  const onUpdate = (values) => {
    const payload = {
      ...values
    }
    setLoadingSubmit(true);
    request({
      url: api.addEdit,
      method: 'POST',
      data: payload,
      onSuccess: (data) => {
        setLoadingSubmit(false);
        ShowToast(data.message, data.status ? Severty.SUCCESS : Severty.ERROR);
      },
      onError: (error) => {
        setLoadingSubmit(false);
        ShowToast(error.response.data.message, Severty.ERROR);
      },
    });
  };

  const fetchSetting = () => {
    setLoadingFetch(true);
    request({
      url: api.view,
      method: 'GET',
      onSuccess: async (response) => {
        const data = response.data;
        form.setFieldsValue(data);
        setLoadingFetch(false);
      },
      onError: (error) => {
        setLoadingFetch(false);
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  useEffect(() => {
    fetchSetting();
  }, []);

  return (
    <Card title={sectionName}>
      
      {loadingFetch ? (
        <div style={{ textAlign: "center", padding: "40px 0" }}> <Spin /> </div>
      ) : (
        <Form
          className="edit-page-wrap"
          form={form}
          onFinish={onUpdate}
          autoComplete="off"
          layout="vertical"
          name="setting_form"
        >
          <Row gutter={[24, 0]}>
            <Col span={24} xs={24} sm={24} md={12}>
              <Form.Item
                label="Free Trial (Days)"
                name="free_trial"
                normalize={value => value.trimStart()}
                rules={[
                  { required: true, message: "Please Enter the free trial period!" },
                  { max: 200, message: "Free trial period should not contain more then 200 characters!" },
                  { min: 1, message: "Free trial period should contain at least 2 characters!" },
                ]}
              >
                <Input autoComplete="off" placeholder="Enter Free Trial Period" />
              </Form.Item>
            </Col>

            <Col span={24} xs={24} sm={24} md={12}>
              <Form.Item
                label="Price Change Duration (Days)"
                name="price_change_days"
                rules={[
                  { required: true, message: "Please enter the price change duration!" },
                ]}
              >
                <InputNumber
                  min={1}
                  max={365}
                  placeholder="Enter number of days"
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>

            <Col span={24} xs={24} sm={24} md={12}>
              <Form.Item
                label="New Product Duration (Days)"
                name="new_product_days"
                rules={[
                  { required: true, message: "Please enter the new product duration!" },
                ]}
              >
                <InputNumber
                  min={1}
                  max={365}
                  placeholder="Enter number of days"
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>
          </Row>

          <Form.Item className="btn-row float-right">
            <Button type="primary" loading={loadingSubmit} htmlType="submit">
              Submit
            </Button>
          </Form.Item>
        </Form>
      )}
    </Card>
  );
}

export default Index;
